import type { ReactNode } from 'react'

import { Button } from '@jotta/ui/Button'
import { cn } from '@jotta/utils/css'

import {
  DialogBody,
  DialogContentPrimitive,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './Dialog'
import { DialogContent } from '@radix-ui/react-dialog'

/**
 * @deprecated Use DialogProps instead
 */
export interface DeprecatedDialogProps {
  /** Callback to run when close button or background is clicked */
  onClose?: () => void
  title?: string
  secondaryTitle?: string
  /** Array of buttons */
  buttons?: {
    /** Button text */
    label: string
    /** Button click handler */
    action: 'close' | React.MouseEventHandler | ((...props: any[]) => void)
    /** Button type */
    type: 'destructive' | 'primary' | 'outline'
    visible?: boolean
    disabled?: boolean
    loading?: boolean
    testId?: string
  }[]
  customButtons?: ReactNode
  children?: ReactNode
  className?: string
}

/**
 * @deprecated Use <Dialog/> instead
 */
export const DeprecatedDialog = ({
  buttons,
  children,
  onClose,
  customButtons,
  className,
  title,
  secondaryTitle,
}: DeprecatedDialogProps) => {
  const closeHandler = onClose
    ? onClose
    : () => {
        console.warn('No close handler registered for dialog')
      }
  return (
    <DialogContentPrimitive className={cn('bg-primary', className)}>
      <DialogHeader showCloseButton={Boolean(onClose)}>
        {secondaryTitle && (
          <DialogDescription>{secondaryTitle}</DialogDescription>
        )}
        {title && <DialogTitle>{title}</DialogTitle>}
      </DialogHeader>

      {children && <DialogBody>{children}</DialogBody>}

      {customButtons ? customButtons : null}
      {buttons && (
        <DialogFooter>
          {buttons
            .filter(
              button => button.visible === undefined || Boolean(button.visible),
            )
            .map(
              ({ type, action, disabled, loading, label, testId }, i, arr) => (
                <Button
                  // Put the cancel button above progress overlay
                  sx={{
                    zIndex:
                      action === 'close' || action === closeHandler ? 2 : 0,
                  }}
                  disabled={!!disabled}
                  loading={!!loading}
                  key={label}
                  className={cn('btn', {
                    'btn-primary': type === 'primary',
                    'btn-destructive': type === 'destructive',
                    'btn-elevated': type === 'outline',
                  })}
                  onClick={action === 'close' ? closeHandler : action}
                  data-testid={testId || label}
                >
                  {label}
                </Button>
              ),
            )}
        </DialogFooter>
      )}
    </DialogContentPrimitive>
  )
}
